<script lang="ts" setup>

</script>

<template>
  <div class=" flex flex-col">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped></style>
